import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { motion } from 'framer-motion';
import 'react-toastify/dist/ReactToastify.css';

const AgreementForm = () => {
  const [loading, setLoading] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL || 'https://localhost:44333/api/';

  const handleDownload = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${baseUrl}Agreement/Get`, {
        method: 'GET',
      });

      if (!response.ok) {
        toast.error('Failed to download agreement.');
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = 'Agreement.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success('Agreement downloaded!');
    } catch (error) {
      console.error('Download error:', error);
      toast.error('An error occurred while downloading.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />

      <motion.div
        className="bg-white p-6 rounded-xl shadow-lg max-w-xl mx-auto"
        data-aos="fade-up"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Agreement Details
        </h2>

        <p className="text-gray-600 mb-6 leading-relaxed text-sm">
          Proposed by <strong>Adspace-tech</strong>.<br />
          For more info, please submit a <strong>QA Ticket</strong>. Our team will contact you ASAP.
        </p>

        <button
          onClick={handleDownload}
          disabled={loading}
          className={`w-full md:w-auto inline-flex items-center justify-center px-5 py-2.5 rounded-md text-sm font-medium transition-all duration-300
            ${loading
              ? 'bg-blue-300 text-white cursor-not-allowed'
              : 'bg-white text-blue-600 border border-blue-500 hover:bg-blue-600 hover:text-white'
            }`}
        >
          {loading ? 'Downloading...' : 'Download Agreement'}
        </button>
      </motion.div>
    </>
  );
};

export default AgreementForm;
